define([
  'js/aofl-js/0.8.0/aofl-modules/__build/aofljs.min'
], function riqChallengeModelServiceImpl(aoflModules) {
  'use strict';
  var storeService = aoflModules.store;

  var riqChallengeModelService = function riqChallengeModelService(
    $q,
    riqApiService,
    dateFormatService
  ) {
    var _this = this;

    riqApiService.setApiEndpoints({
      getChallengeReport: 'challenge_report',
      getChallengeById: 'challenge_get',
      getChallenges: 'challenge_get_all',
      getGroup: 'group_get'
    });

    var groupProfileDetailFields = [
      'name',
      'last_name',
      'avatar',
      'invitation_status',
      'contact_email',
      'contact_language',
      'active_reading_level',
      'active_reading_level_type',
      'created_date'
    ];

    var _handleGetActiveChallenge = function _handleGetActiveChallenge(
      _payload
    ) {
      return Object.keys(_payload).filter(function(challengeId) {
        return _payload[challengeId].active === '1';
      })[0];
    };

    var getChallengeReport = function getChallengeReport(data, _cache) {
      var clientTimestamp = dateFormatService.formatDate(
        Date.now(),
        'yyyy-MM-dd HH:mm:ss'
      );
      data.clientTimestamp = clientTimestamp;
      return riqApiService.get('getChallengeReport', data, _cache);
    };

    var _sortActiveReadingLevels = function _sortActiveReadingLevels(students) {
      students.forEach(function(profile) {
        var profileDetails = profile.profileDetails;
        if (profileDetails && profileDetails.activeReadingLevel) {
          profileDetails.activeReadingLevel.concat([]).sort();
        }
      });
    };

    var _handleGetFullChallengeReport = function _handleGetFullChallengeReport(
      payload
    ) {
      var state = storeService.getState();
      var ownerUserUuid = state.user.userUuid;
      var challengeGroup = payload[0];
      var challengeMinutes = payload[1];
      var students = challengeGroup.group.profiles;
      var totalStudents = challengeMinutes.total - 1;
      var completedStudents = challengeMinutes.completed;
      var studentMinutes = challengeMinutes.profileReports;
      var connectedStudents = 0;
      // TODO move to a decorator.
      students.sort(function(a, b) {
        var nameA =
          typeof a.profileDetails === 'object' && a.profileDetails.name
            ? a.profileDetails.name
            : '';
        var nameB =
          typeof b.profileDetails === 'object' && b.profileDetails.name
            ? a.profileDetails.name
            : '';
        return nameA.localeCompare(nameB);
      });
      _sortActiveReadingLevels(students);

      var studentsReport = students
        .filter(function(student) {
          return student.userUuid !== ownerUserUuid;
        })
        .map(function(student) {
          studentMinutes.map(function(studentMinute) {
            if (student.profileUuid === studentMinute.profileUuid) {
              student.timeSpent = studentMinute.timeSpent;
            }
            return studentMinute;
          });
          if (
            student.profileDetails &&
            student.profileDetails.invitationStatus === 'connected'
          ) {
            connectedStudents += 1;
          }
          return student;
        });

      return {
        students: studentsReport,
        total: totalStudents,
        completed: completedStudents,
        connected: connectedStudents
      };
    };

    var _getGroup = function _getGroup(profileDetails, _cache) {
      var state = storeService.getState();
      var groupUuid = state.user.groupUuid;
      var profileDetailsOptions = profileDetails || [
        'name',
        'last_name',
        'avatar'
      ];
      return riqApiService.get(
        'getGroup',
        {
          groupUuid: groupUuid,
          profileDetails: profileDetailsOptions
        },
        _cache
      );
    };

    var getFullChallengeReport = function getFullChallengeReport(
      data,
      _cacheGroup
    ) {
      var challengeStudents = _getGroup(groupProfileDetailFields, _cacheGroup);
      var challengeMinutes = getChallengeReport(data, false);
      return $q
        .all([challengeStudents, challengeMinutes])
        .then(_handleGetFullChallengeReport)
        .catch(function(error) {
          throw error;
        });
    };

    var getChallengeById = function getChallengeById(data) {
      return riqApiService.get('getChallengeById', data);
    };

    var getChallenges = function getChallenges(data) {
      return riqApiService.get('getChallenges', data);
    };

    var getActiveChallenge = function getActiveChallenge(data) {
      return riqApiService
        .get('getChallenges', data)
        .then(_handleGetActiveChallenge)
        .catch(function(error) {
          throw error;
        });
    };

    _this.getChallengeReport = getChallengeReport;
    _this.getFullChallengeReport = getFullChallengeReport;
    _this.getChallengeById = getChallengeById;
    _this.getActiveChallenge = getActiveChallenge;
    _this.getChallenges = getChallenges;
  };

  return riqChallengeModelService;
});
